import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { contractsRequestData } from '@shared/model/contracts.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ResponseBody } from '@shared/model/response-body.models';
import { ContractRequestData } from '@shared/model/contract-request.model';
import { ContractResponseData } from '@shared/model/contract-response.model';
import { ContractSendFile } from '@shared/model/contract-file-send.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ContractsService {
  private readonly baseUrl = environment.baseUrl;
  private readonly routePrefix = 'api/v1/admin';
  constructor(private http: HttpClient, private snackBar: MatSnackBar) { }

  getContracts(pageSize: number, startPage: number): Observable<contractsRequestData> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/contract/contract?startPage=${startPage}&pageSize=${pageSize}`
      )
      .pipe(map((res: any) => res.data));
  }

  getContractsRevision(
    pageSize: number,
    startPage: number
  ): Observable<contractsRequestData> {
    return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/contract/revision-requests?startPage=${startPage}&pageSize=${pageSize}`
      )
      .pipe(map((res: any) => res.data));
  }
  postContracts(body: ContractSendFile): Observable<ResponseBody> {
    return this.http.post(`${this.baseUrl}/${this.routePrefix}/contract/contract`,
    body).pipe(tap((res: ResponseBody) => {
      }
      ));
  }

  getContractRequest(id: number): Observable<ContractRequestData> {
    return this.http
      .get(`${this.baseUrl}/${this.routePrefix}/contract/request/${id}`)
      .pipe(map((res: any) => res.data));
  }

  getContractResponse(requestId: number, providerId: number): Observable<ContractResponseData> {
    return this.http
      .get(`${this.baseUrl}/${this.routePrefix}/contract/response/${requestId}/${providerId}`)
      .pipe(map((res: any) => res.data));
  }

  getContractById(id: number): Observable<ResponseBody> {
    return this.http
      .get(`${this.baseUrl}/${this.routePrefix}/contract/contract/${id}`)
      .pipe(map((res: any) => res));
  }
  changeRevisionStatus(data): Observable<ResponseBody> {
    return this.http.patch(`${this.baseUrl}/${this.routePrefix}/contract/change-revision-status`, data).pipe(map((res: any) => res));

  }
  finalApprove(data): Observable<ResponseBody> {
    return this.http.patch(`${this.baseUrl}/${this.routePrefix}/contract/final-approve`, data)
      .pipe(map((res: any) => {
        if (res.status === 200) {
          this.snackBar.open(res.message, 'Undo', {
            duration: 1000
          })
          return res;
        }
        else {
          this.snackBar.open(res.message, 'Undo', {
            duration: 1000
          })
        }
      }
      ));
  }
}
